<template>
  <aside class="aside">
    <nav class="nav">
      <router-link class="nav__link" v-for="(option, index) in menu" :key="index" :to="option.path">
        <img class="nav__icon" :src="option.icon" alt=""> {{option.text}}
        </router-link>
    </nav>
    <div class="aside__options">
      <button class="aside__option" @click="logout">Cerrar Sesión</button>
    </div>
  </aside>
</template>

<script>
import { auth } from "@/assets/js/libs/sessions";
export default {
  data: function() {
    return {
			menu: [
        {
          path: {
            name: "home"
          },
          icon: "/static/icons/house-outline.svg",
          text: "Inicio"
        },
        {
          path: {
            name: "userList",
            params: {
              page: 1
            }
          },
          icon: "/static/icons/nova/solid/user-female.svg",
          text: "Usuarios"
        },
        {
          path: {
            name: "customerList",
            params: {
              page: 1
            }
          },
          icon: "/static/icons/businessman-outline.svg",
          text: "Clientes"
        },
        {
          path: {
            name: "postList",
            params: {
              page: 1
            }
          },
          icon: "/static/icons/businessman-outline.svg",
          text: "Productos"
        },
        {
          path: {
            name: "pageList",
            params: {
              page: 1
            }
          },
          icon: "/static/icons/businessman-outline.svg",
          text: "Páginas"
        },
        {
          path: {
            name: "portfolioList",
            params: {
              page: 1
            }
          },
          icon: "/static/icons/businessman-outline.svg",
          text: "Portafolio"
        },
        {
          path: {
            name: "sectorList",
            params: {
              page: 1
            }
          },
          icon: "/static/icons/businessman-outline.svg",
          text: "Sectores"
        },
        {
          path: {
            name: "galleryList",
            params: {
              page: 1
            }
          },
          icon: "/static/icons/mountain-painting.svg",
          text: "Galerías"
        },
        {
          path: {
            name: "media"
          },
          icon: "/static/icons/mountain-painting.svg",
          text: "Media"
        }
      ]
    };
  },
  methods: {
    logout: function() {
      auth.logout().then(() => {
        this.$store.commit("logout");
        let notification = {
          title: "HA CERRADO SESIÓN",
          text: "Ha cerrado sesión correctamente, te esperamos de vuelta.",
          type: "success"
        };
        this.$store.commit("notificate", notification);
        this.$router.push({ name: "login" });
      });
    }
  }
};
</script>

<style lang="sass" scoped>
@import "../../assets/sass/components/layout/_aside"
</style>



// WEBPACK FOOTER //
// src/components/layout/nav.vue